const mergeViewRules = {
    template: [(v) => Boolean(v.trim()) || 'HTML Code Secure is required'],
};

export default mergeViewRules;
